import { createSlice } from '@reduxjs/toolkit'
import aiController from 'helpers/AIController'

export const chatInitialState = {
  history: {
    chatLog: [],
    activeHistory: [],
    chatId: null,
    showHistory: false,
  },
  form: {
    inputValue: '',
    language: { value: 'auto', label: 'auto' },
    isGuru: false,
    story: null,
    isAutoAudio: false,
    isSearchWeb: false,
    model: { ...aiController.getDefaultTextModel(), description: undefined },
    isSettingsOpen: true,
    searchEngine: 'perplexity',
  },
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState: chatInitialState,
  reducers: {
    setChatInputHistory: (state, action) => {
      state.history = action.payload
    },
    setChatForm: (state, action) => {
      state.form = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setChatInputHistory, setChatForm } = chatSlice.actions

//selectors
export const chatInputHistory = (state) => state.chat.history
export const chatForm = (state) => state.chat.form
export default chatSlice.reducer
